<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <!--EmFilterTree-->
            <em-filter-element-tree class="col-lg-3 float-lg-left" @onNodeClick="findChildren"></em-filter-element-tree>
            <div class="float-lg-right col-lg-9">
                <div id="accordionFilter" class="content">
                    <div class="card">
                        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                             data-parent="#accordionFilter">
                            <div class="card-body">
                                <form>
                                    <em-filter :entity="modelName" ref="emListFilter"
                                               @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"/>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="sithMesMstBomResultTable" class="content">
                    <div class="card my-1">
                        <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                             data-parent="#accordionResult">
                            <div class="card-body">
                                <em-table :entity="modelName"
                                          ref="emTable"
                                          withCustomRowActions exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                          @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                          @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                    <template #customRowActions="{row}">
                                        <b-button-group>
                                            <em-button
                                                    v-if="haveParentCode(row)"
                                                    type="gotoGrandParent"
                                                    v-bind:class="'btn btn-outline-primary btn-sm'"
                                                    @click="findParent(row)">
                                            </em-button>
                                            <em-button type="gotoChild"
                                                       v-bind:class="'btn btn-outline-primary btn-sm'"
                                                       @click="findChildren(row)">
                                            </em-button>
                                        </b-button-group>
                                    </template>
                                    <template #left-header>
                                        <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-file-import"
                                            :disabled= false
                                            custom-label="导入BOM"
                                            v-bind:class="'btn btn-outline-primary btn-sm'"
                                            v-b-modal.modal-updateBom>
                                        </em-button>
                                        <!-- 留给测试用 -->
                                        <em-button type="check" custom-icon="fa fa-fw fa-lg fa-list"
                                        :disabled="noPermission"
                                        custom-label="手动同步SAP数据"
                                        :showName="true"
                                        v-bind:class="'btn btn-outline-primary btn-sm'"
                                        confirm-text="当前BOM会被删除，确认同步？"
                                        @click="syncSapBom()"
                                    >    
                                    </em-button>
                                    </template>
                                </em-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"/>
        <b-modal id="modal-updateBom" title="导入BOM" hide-footer>
            <b-form @submit="handleSubmit" @reset="handleReset">
            <b-form-group
            id="templateFile"
            label="选择数据源文件:"
            label-for="input-dataFile"
            invalid-feedback="必须选择数据源">
            <b-form-file id="input-dataFile" v-model="file" ref="file-input" class="mb-2" :browse-text="$t('btn.basic.browse')" placeholder="请选择数据文件" :file-name-formatter="formatNames" accept=".xlsx" required></b-form-file>
            </b-form-group>

            <div class="form-check mt-2">
                <input class="form-check-input is-invalid" type="checkbox" value="" id="agreement" aria-describedby="invalidCheckFeedback" required>
                <label class="form-check-label" for="agreement">确认覆盖原始数据</label>
                <div id="invalidCheckFeedback" class="invalid-feedback">请确认</div>
            </div>

            <b-row align-h="end" style="margin-top: 30px">
                <b-button type="submit" variant="primary">导入</b-button>
                <b-button type="reset" variant="light">取消</b-button>
            </b-row>
            </b-form>
        </b-modal>
    </div>
</template>
<script>
    // Author YuJiaBei
    // Date 2021-02-23 15:59:42

    import emLevelTreeListMixin from "@/mixin/em/levelTree/list";
    import EmFilterTree from "@/components/em/EmFilterTree";
    import EmFilter from "@/components/em/EmFilter";
    import emCommonApiMixin from "@/mixin/em/common/api";
    import commonViewsUtil from "@/utils/commonViewsUtil";
    import EmFilterElementTree from "@/components/em/EmFilterElementTree"

    export default {
        name: "sithMesMstBomLevelTreeListView",
        mixins: [emLevelTreeListMixin,emCommonApiMixin],
        components: {EmFilter, EmFilterTree,EmFilterElementTree},
        props:{
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
        data() {
            return {
                file: null,
                noPermission: false,
            }
        },
        methods: {
            formatNames(files) {
                return files.length === 1 ? files[0].name : `${files.length} files selected`
            },
            handleSubmit(event) {
                let self = this;
                event.preventDefault()
                var formData = new FormData();
                formData.append('file',this.file);

                this.$_emApiMixin_post(`${this.$_emApiMixin_entityBaseApi(this.modelName)}/updateData`, formData)
                .then(response => {
                    commonViewsUtil.showSuccess(this, "更新成功")
                    self.$refs.emListFilter.doQuery()
                })

                 this.$nextTick(() => {
                    this.$bvModal.hide('modal-updateBom')
                })
            },
            handleReset() {
                this.selectedMachineType = null;
                this.file = null;
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-updateBom')
                })
            },
            findChildren(treeNode) {
                commonViewsUtil.gotoHolderList(this, this.modelName, {
                parentCodeFilter: treeNode.component
                }, {parentCode: treeNode.component})
            },
            haveParentCode(entity) {
                let component = entity.parentCode;
                if(component!="" && component!=null && component!=undefined ) {
                    return true;
                }
                return false;
            },
            findParent(entity) {
                commonViewsUtil.gotoHolderList(this, this.modelName, {
                componentFilter: entity.parentCode
                }, {component: entity.parentCode})
            },
            syncSapBom() {
                let self = this;
                let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/syncSapBom`;
                this.$_emApiMixin_post(url, {})
                .then(response => {
                    commonViewsUtil.showSuccess(this, "同步完成")
                })
            }
        }
    }
</script>